/**
 * `/$org/apps/imanage/saved`: see IManageSavedPage.
 *
 * @module routes/$org.apps.imanage.saved
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageSavedPage } from "../components/apps/imanage/IManagePages";
import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";

function IManageSavedRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageSavedPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/saved")({
  validateSearch: parseIManageSearch,
  component: IManageSavedRoute,
});
